import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { digits } from '@/ui/digits'

/**
 * 숫자만 받는 칸. 비우면 그 자원은 본문에서 빠지고, 빠진 자리가 무엇이 되는지는 placeholder 가 말한다 —
 * 사양과 직위에서는 `자유` 다.
 *
 * 사양(`views/Catalog.tsx`)·직위(`views/QuotaTiers.tsx`)가 같은 칸을 쓰고, 사양을 바꾸는 창의 칸(`views/vm/SpecCards.tsx`)도
 * 같은 걸러개다. 화면마다 칸을 따로 그리면 한쪽에서만 `type="number"` 를 쓰거나 걸러개가 빠져
 * **비운 칸과 잘못 친 칸이 구별되지 않는다** — 비운 칸이 뜻을 가진 화면에서는 그것이 곧 틀린 값이 간다는 말이다.
 *
 * `hint` 는 그 칸이 받는 범위를 치는 동안 말하는 조용한 줄이고, `bad` 면 같은 자리가 막힘이 된다.
 * 누르고 나서 거절로 알게 되면 사람은 고칠 곳을 모른 채 같은 일을 되풀이한다.
 */
export function NumberField({
  id,
  label,
  value,
  placeholder,
  busy,
  onChange,
  hint = '',
  bad = false,
}: {
  id: string
  label: string
  value: string
  placeholder: string
  busy: boolean
  onChange: (v: string) => void
  hint?: string
  bad?: boolean
}) {
  return (
    <div className="grid gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      <Input
        id={id}
        value={value}
        inputMode="numeric"
        placeholder={placeholder}
        autoComplete="off"
        disabled={busy}
        aria-invalid={bad || undefined}
        onChange={(e) => {
          const next = digits(e.target.value)
          if (next !== null) onChange(next)
        }}
      />
      {hint === '' ? null : (
        <span className={bad ? 'text-[11px] text-danger-ink' : 'text-[11px] text-muted-foreground'}>{hint}</span>
      )}
    </div>
  )
}
